/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Sms_SentInputs */

const tr_geliver_tracking_sms_sent = /** @type {(inputs: Geliver_Tracking_Sms_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + SMS gönderildi`)
};

const en_geliver_tracking_sms_sent = /** @type {(inputs: Geliver_Tracking_Sms_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + SMS sent`)
};

const de_geliver_tracking_sms_sent = /** @type {(inputs: Geliver_Tracking_Sms_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + SMS gesendet`)
};

const ru_geliver_tracking_sms_sent = /** @type {(inputs: Geliver_Tracking_Sms_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` + SMS отправлено`)
};

/**
* | output |
* | --- |
* | "+ SMS sent" |
*
* @param {Geliver_Tracking_Sms_SentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_sms_sent = /** @type {((inputs?: Geliver_Tracking_Sms_SentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Sms_SentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_sms_sent(inputs)
	if (locale === "de") return de_geliver_tracking_sms_sent(inputs)
	if (locale === "ru") return ru_geliver_tracking_sms_sent(inputs)
	return tr_geliver_tracking_sms_sent(inputs)
});